import { Fragment } from "react";

export default function StaedteError() {

    return(
        <Fragment>
            <div id="main-content" className="staedte_public_main">
                <div id="staedte_noCity_imageBox">
                    <span>
                        <img decoding="async" width="7500" height="3750" src={`https://${window.location.hostname}/wp-content/plugins/online-vvk/public/ticket-shop/img/website_Ticketing_geschlossen.png`} alt="" title="Location not found" sizes="(min-width: 0px) and (max-width: 480px) 480px, (min-width: 481px) and (max-width: 980px) 980px, (min-width: 981px) and (max-width: 1280px) 1280px, (min-width: 1281px) 7500px, 100vw" className="wp-image-13914" />
                    </span>
                </div>
                <div id="staedte_noCity_textBox">
                    <h2>
                        {window.staedteFrontendShortcodeData.i18n.weAreNotInYourCity}<br></br>
                        {window.staedteFrontendShortcodeData.i18n.requestUs}
                    </h2>
                    <div id="staedte_noCity_buttonBox">
                        <div id="button-form-noCityKontakt">
                            <a id="button-noCityKontakt" className="noCityButton" href={`https://${window.location.hostname}/kontakt`}>
                                {window.staedteFrontendShortcodeData.i18n.requestYourCity}
                            </a>
                        </div>

                        <div id="button-form-noCityStadte">
                            <a id="button-noCityStaedte" className="noCityButton" href={`https://${window.location.hostname}/staedte`}>
                                {window.staedteFrontendShortcodeData.i18n.toTheCities}
                            </a>
                        </div>
                    </div>		
                </div>
            </div>
        </Fragment>
    );

}